import React from 'react';

const ThemeSevenFooter = ({ operator }) => {
  return operator ? (
    <div className="themes-theme-seven-footer">
      <div className="footer-wrapper new-container">
        <div className="left">
          <div className="footer-logo ">
            <a href="/">
              <img src={operator && operator.footer_logo} alt="" />
            </a>
          </div>
          <div className="left-text bold-text">
            <span>Síguenos</span>
            <a href="https://www.facebook.com/busesfernandez1947/" target="_blank">
              <span className="fb"></span>
            </a>
            <a href="https://www.instagram.com/busesfernandez/" target="_blank">
              <span className="insta"></span>
            </a>
          </div>
        </div>
        <div className="right bold-text">
          <div className="text-right">
            <p>Buses Fernández 2022.</p>
            <p>Todos los derechos reservados ©</p>
            <p>
              Powered by{' '}
              <a href="https://kupos.cl" target="_blank">
                kupos.cl
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ThemeSevenFooter;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeSeven/common/ThemeSevenFooter.js